import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Typography,
} from "@mui/material";
import dayjs from "dayjs";
import { useState } from "react";
import TableActions from "src/common/TableActions";
import ModalsWrapper from "src/components/Modals/ModalsWrapper";
import type { IStallExhibitorInfo } from "src/Types/module/fairStall/fairStallType";
import { getStatusLabelInvoiceStatus } from "src/Utils/Combined";
import SpecificStallUpdate from "../exhibitor/SingleExhibitorDetails/SpecificStallUpdate";

function StallWiseExhibitor({
	stallExhibitorInfo,
}: {
	stallExhibitorInfo: IStallExhibitorInfo[];
}) {
	const [showModal, setShowModal] = useState<{
		showModal: boolean;
		id: string | number;
	}>({ showModal: false, id: "" });
	return (
		<TableContainer>
			<Typography
				textAlign='center'
				gutterBottom
				variant='h3'
				component='div'
			>
				Applied Exhibitor
			</Typography>
			<Table>
				<TableHead>
					<TableRow>
						<TableCell>SL.</TableCell>
						<TableCell align='center'>Date</TableCell>
						<TableCell align='center'>Organization</TableCell>
						<TableCell align='center'>Email</TableCell>
						<TableCell align='center'>Phone</TableCell>
						<TableCell align='center'>Stall Status</TableCell>
						<TableCell align='center'>Payment Status</TableCell>
						<TableCell align='center'>Action</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{stallExhibitorInfo?.length ? (
						stallExhibitorInfo?.map((details, index) => (
							<TableRow hover key={details.stall_id}>
								<TableCell>{index + 1}</TableCell>
								<TableCell align='center'>
									{dayjs(details.created_at).format(
										"DD-MMM-YYYY"
									)}
								</TableCell>
								<TableCell align='center'>
									{details?.user_fair_member_company_name}
								</TableCell>
								<TableCell align='center'>
									{details?.user_fair_member_contact_email}
								</TableCell>
								<TableCell align='center'>
									{
										details?.user_fair_member_company_telephone
									}
								</TableCell>
								<TableCell align='center'>
									{getStatusLabelInvoiceStatus(
										details?.status
									)}
								</TableCell>
								<TableCell align='center'>
									{getStatusLabelInvoiceStatus(
										details?.invoice_status
									)}
								</TableCell>
								<TableActions
									showView
									viewLink={`/exhibitor/list/${details?.user_fair_member_id}`}
									align='center'
									showEdit
									handleEditFun={() => {
										setShowModal((prev) => ({
											...prev,
											showModal: !showModal.showModal,
											id: details.id,
										}));
									}}
								/>
							</TableRow>
						))
					) : (
						<h2>Not Found</h2>
					)}
				</TableBody>
			</Table>

			<ModalsWrapper
				setShowModal={() => {
					setShowModal((prev) => ({
						...prev,
						showModal: !showModal.showModal,
					}));
				}}
				showModal={showModal?.showModal}
				modalData={{ title: "Update Status of Stall" }}
				maxWidth='xs'
			>
				<SpecificStallUpdate
					showModal={showModal}
					handleClose={() =>
						setShowModal((prev) => ({
							...prev,
							showModal: !showModal.showModal,
						}))
					}
				/>
			</ModalsWrapper>
		</TableContainer>
	);
}

export default StallWiseExhibitor;
